import { fromJS, Map } from 'immutable';
import moment from 'moment';

export function request(state) {
    return state
        .set('state', 'IN_PROGRESS');
}

export function error(state, { errors }) {
    return state
        .set('state', 'ERROR')
        .set('errors', fromJS(errors));
}

export function finish(state, { notifications }) {
    let items = {};

    for (let item of notifications) {
        if (item.expiresAt && moment().isAfter(item.expiresAt)) {
            continue;
        }
        items[item.id] = item;
    }

    return state
        .set('state', 'FINISHED')
        .set('items', fromJS(items));
}
